<template>
  <div v-if="client">
    <h1>Operator client</h1>
    <v-btn :to="{name:'operatorClients'}">
      <v-icon>chevron_left</v-icon>Operator clients
    </v-btn>
    <Client :value="client" />
    <Operators :operators="operators" />
  </div>
</template>

<script>
import Client from "@/components/operator/Client";
import Operators from "@/components/operator/Operators";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "OperatorClient",
  metaInfo() {
    return {
      title: "Operator client",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { Client, Operators },
  data() {
    return { client: null, operators: [] };
  },
  methods: {
    fetchClient() {
      nbmlaw
        .get(`/cors/admin/file/operatorClients/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.client = response.data;
        });
    },
    fetchOperators() {
      nbmlaw
        .get(
          `/cors/admin/file/operatorClients/${this.$route.params.id}/operators`
        )
        .then(response => {
          // console.log(response.data);
          this.operators = response.data;
        });
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchClient();
        this.fetchOperators();
      }
    }
  }
};
</script>

<style>
</style>
